module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h2', {
    attrs: {
      "id": "kuai-su-shang-shou"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#kuai-su-shang-shou",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" 快速上手")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "wan-zheng-yin-ru"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#wan-zheng-yin-ru",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" 完整引入")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "hljs"
  }, [_vm._v("import Vue from 'vue';\nimport ZanUI from '@youzan/zanui-vue';\nimport '@youzan/zanui-vue/lib/zanui-css/index.css';\n\nVue.use(ZanUI);\n")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "an-xu-yin-ru"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#an-xu-yin-ru",
      "aria-hidden": "true"
    }
  }, [_vm._v("¶")]), _vm._v(" 按需引入")]), _vm._v(" "), _c('pre', [_c('code', {
    staticClass: "hljs"
  }, [_vm._v("import Vue from 'vue';\nimport { Button, Cell } from '@youzan/zanui-vue';\nimport '@youzan/zanui-vue/lib/zanui-css/button.css';\nimport '@youzan/zanui-vue/lib/zanui-css/cell.css';\n\nVue.component(Button.name, Button);\nVue.component(Cell.name, Cell);\n")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa40db88!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/quickstart-10.vue
// module id = 313
// module chunks = 0